import React from 'react';
import { MobileTray } from '../../MobileTray/MobileTray';
import classNames from 'classnames';
import { ArrowBack, Close } from '../../icons';
import { MobileSearchForm } from './mobile/MobileSearchForm';
import { useSearch } from './use-search';

export const MobileSearchTray = () => {
  const { displaySearchWidget, closeSearchWidgetFn, getMobileTrayView, mobileTrayViewValue, setMobileTrayView, defaultActivityValue, setActivityValue, defaultLocationValue, setLocationValue } = useSearch();

  const handleBackArrow = () => {
    if (mobileTrayViewValue === 'activity') {
      setActivityValue(defaultActivityValue);
    } else if (mobileTrayViewValue === 'location') {
      setLocationValue(defaultLocationValue);
    }
    setMobileTrayView('main');
  };

  return (
    <MobileTray
      isVisible={displaySearchWidget}
      backgroundOverlay
      setIsVisible={() => (
        closeSearchWidgetFn()
      )}
      height="calc(100% - 32px)"
      hidePullTab
    >
      <div
        className={classNames('flex middle responsive-padding',
          { 'border-bottom-gray-200': 'main' === mobileTrayViewValue }
        )}
        style={{ paddingTop: '16px', paddingBottom: '32px' }}
      >
        { 'main' !== mobileTrayViewValue &&
            <ArrowBack
              onClick={handleBackArrow}
              style={{ fontSize: '24px', marginRight: '8px' }}
            />
        }
        <label
          htmlFor="activity-input"
          className="activity_input_label text-gray-900 h4"
          style={{ marginTop: 0 }}
        >
          {getMobileTrayView().label}
        </label>
        {
          'main' === mobileTrayViewValue &&
          <div style={{ marginLeft: 'auto' }}>
            <button
              className="btn-clear flex center middle"
              onClick={(e) => {
                e.preventDefault();
                closeSearchWidgetFn();
              }}
            >
              <Close style={{ fontSize: '24px' }} />
            </button>
          </div>
        }
      </div>
      <MobileSearchForm />
    </MobileTray>
  );
};
